import type { RouteRecordRaw } from 'vue-router';
import md from '@/router/middlewares';
import site from './site';
import roles from '@/constants/roles';

const clientInfo = [
    {
        meta: {
            title: 'clientPage.sites',
            img: 'site.svg',
            allowedRoles: ['all'],
        },
        path: 'sites',
        name: 'clientSites',
        component: () => import('@/views/clients/ClientSites.vue'),
    },
    {
        meta: {
            title: 'clientPage.clientInfo',
            img: 'ClientInfo.svg',
            allowedRoles: ['all'],
        },
        path: 'info',
        name: 'clientInfo',
        component: () => import('@/views/clients/ClientInformation.vue'),
    },
    {
        meta: {
            title: 'clientPage.contacts',
            img: 'Contacts.svg',
            allowedRoles: ['all'],
        },
        path: 'contacts',
        name: 'clientContacts',
        component: () => import('@/views/contacts/Contacts.vue'),
    },
    {
        meta: {
            title: 'contacts.addContact',
            img: 'Contacts.svg',
            hidden: true,
            allowedRoles: ['all'],
        },
        path: 'contacts/add',
        name: 'clientContactAdd',
        component: () => import('@/views/contacts/ContactAddPage.vue'),
    },
    {
        meta: {
            title: 'clientPage.assignedUsers',
            img: 'AssignedUsers.svg',
            allowedRoles: [
                roles.ADMINISTRATOR.value,
                roles.MANAGER.value,
                roles.SERVICE_TECHNICIAN.value,
                roles.LABORATORY_MANAGER.value,
                roles.LABORATORY_TECHNICIAN.value,
                roles.LABORATORY_CHEMIST.value,
                roles.LABORATORY_MICROBIOLOGIST.value,
                roles.SALES_REPRESENTATIVE.value,
            ],
        },
        path: 'assignedUsers',
        name: 'clientAssignedUsers',
        component: () => import('@/views/clients/AssignedUsers.vue'),
    },
    {
        meta: {
            title: 'clientPage.manageClientTeam',
            img: 'ManageClientTeam.svg',
            allowedRoles: [
                roles.ADMINISTRATOR.value,
                roles.MANAGER.value,
                roles.SERVICE_TECHNICIAN.value,
                roles.LABORATORY_MANAGER.value,
                roles.LABORATORY_TECHNICIAN.value,
                roles.LABORATORY_CHEMIST.value,
                roles.LABORATORY_MICROBIOLOGIST.value,
                roles.SALES_REPRESENTATIVE.value,
            ],
        },
        path: 'manageClientTeam',
        name: 'clientManageClientTeam',
        component: () => import('@/views/clients/ClientTeam.vue'),
    },
];
const client: RouteRecordRaw = {
    name: 'client-page',
    path: '/clients/:clientId',
    alias: '/clients/:clientId',
    redirect: { name: 'clientSites' },
    meta: {
        middlewares: [md.auth, md.accessControl, md.getClientInfo],
    },
    children: [site, ...clientInfo],
};

export default client;
export { clientInfo };
